import { render, staticRenderFns } from "./GridBody.vue?vue&type=template&id=0b779ca2&"
import script from "./GridBody.vue?vue&type=script&lang=js&"
export * from "./GridBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports